<div class="engagement-panel">
  @if (openUserRemovePopup) {
    <kendo-popup
      (close)="close()"
      [animate]="animate"
      [anchor]="anchor"
      [anchorAlign]="anchorAlign"
      [popupAlign]="popupAlign"
      popupClass="full-height-popup"
      [margin]="margin"
      >
      <div #popupContent class="add-client-container">
        <div class="popup-header">
          <div class="popup-title">Remove User</div>
          <button class="close-btn" (click)="close()">&#x2715;</button>
        </div>
        <div>
          @if (isDisplayloader) {
            <div class="setloader-position">
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                size="default"
                color="#225EFF"
                type="ball-triangle-path" [fullScreen]="false">
              </ngx-spinner>
            </div>
          }
          @if (!isDisplayloader) {
            <div class="engagement-details-section">
              @if (userRemovalDetailsForm) {
                <form class="k-form k-form-md"
                  [formGroup]="userRemovalDetailsForm">
                  <div class="wrapper">
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Name</h3>
                        </div>
                      </kendo-card-header>
                      <kendo-card-body class="k-custom-card-body">
                        <!-- <div> -->
                        <div class="k-d-flex">
                          <div class="k-column-1">
                            <h4 style="margin-bottom: 0px">
                              {{ removeUserData?.name }}
                            </h4>
                          </div>
                        </div>
                      <!-- </div> -->
                    </kendo-card-body>
                  </kendo-card>
                  <kendo-card class="k-custom-card w-100">
                    <kendo-card-header class="k-custom-card-header">
                      <div>
                        <h3 kendoCardTitle>Engagement</h3>
                      </div>
                    </kendo-card-header>
                    <kendo-card-body class="k-custom-card-body">
                      <div class="k-d-flex">
                        <div class="k-column-1">
                          <h4 style="margin-bottom: 0px">
                            {{ removeUserData?.engagementName }}
                          </h4>
                        </div>
                      </div>
                    </kendo-card-body>
                  </kendo-card>
                  <kendo-card class="k-custom-card w-100">
                    <kendo-card-header class="k-custom-card-header">
                      <div>
                        <h3 kendoCardTitle>Role</h3>
                      </div>
                    </kendo-card-header>
                    <kendo-card-body class="k-custom-card-body k-card-body">
                      <div class="k-column-1">
                        <h4 style="margin-bottom: 0px">
                          {{
                          removeUserData?.userRequestRoleTypeName
                          }}
                        </h4>
                      </div>
                    </kendo-card-body>
                  </kendo-card>
                  <kendo-card class="k-custom-card w-100">
                    <kendo-card-header class="k-custom-card-header">
                      <div>
                        <h3 kendoCardTitle>Activity Stream</h3>
                      </div>
                    </kendo-card-header>
                    @if (removeUserData?.activityStream) {
                      <kendo-card-body class="k-custom-card-body k-card-body">
                        <kendo-timeline [events]="removeUserData?.activityStream"
                          [collapsibleEvents]="false"
                          [alterMode]="false">
                        </kendo-timeline>
                      </kendo-card-body>
                    }
                  </kendo-card>
                  @if (((isApprovalUser && requestStatus === RequestStatusEnum.Pending) || (!isApprovalUser && requestStatus !== RequestStatusEnum.Completed && requestStatus !== RequestStatusEnum.Rejected))) {
                    <div>
                      <kendo-label text="Comments " style="color: black">
                        <span style="color: #757575"><i>(Optional)</i></span>
                      </kendo-label>
                      @if (isApprovalUser) {
                        <kendo-textarea placeholder="Comments"
                          formControlName="ApprovalUserComment"
                          fillMode="none"
                          class="custom-textarea"
                          [rows]="3"
                        resizable="vertical"  [maxlength]="256"></kendo-textarea>
                      }
                      @if (!isApprovalUser) {
                        <kendo-textarea placeholder="Comments"
                          formControlName="SupportUserComment"
                          fillMode="none"
                          class="custom-textarea"
                          [rows]="3"
                          resizable="vertical"
                        [ngClass]="{'completed': message !== ''}"  [maxlength]="256"></kendo-textarea>
                      }
                    </div>
                  }
                </div>
                <div>
                  <p style="font-size: 20px">
                    <span style="color: red">Warning:</span> Removing User
                  </p>
                  <div>
                    Are you sure you want to remove this user from the client
                    engagement?
                    <br />
                    <br />
                    The user will lose access to all related information and tasks.
                  </div>
                </div>
              </form>
            }
            <div>
              @if (message !== '') {
                <h4 style="color: red">
                  {{ message }}
                </h4>
              }
            </div>
          </div>
        }
        @if (!isDisplayloader && isApprovalUser) {
          <div class="form-buttons">
            <button kendoButton type="button" (click)="approveOrDenyUserRemovalRequestDetails(true)" class="request-button" [disabled]="requestStatus !== RequestStatusEnum.Pending" themeColor="none">APPROVE</button>
            <button kendoButton type="button" (click)="approveOrDenyUserRemovalRequestDetails(false)" style="width: 100%; background-color: orange; font-weight: 600" [disabled]="requestStatus !== RequestStatusEnum.Pending" themeColor="none">DENY</button>
            <button kendoButton type="button" (click)="cancelUserRemovalRequestDetails()" style="width: 100%;margin-left: 10px;color: gray;font-weight: 600;">REVIEW LATER</button>
          </div>
        }
        @if (!isDisplayloader && !isApprovalUser) {
          <div class="form-buttons">
            <button kendoButton type="button" (click)="completeUserRemovalRequestDetails()" class="removal-button" [disabled]="requestStatus === RequestStatusEnum.Completed || requestStatus === RequestStatusEnum.Rejected">REMOVE</button>
            <button kendoButton type="button" (click)="cancelUserRemovalRequestDetails()" class="w-100">CANCEL</button>
          </div>
        }
      </div>
    </div>
  </kendo-popup>
}
</div>

@if (openUserRemovePopup) {
  <div class="k-popup-backdrop"></div>
}
